import { CustomerGroup } from "utils/api/client/vendors/customer-group"
import { Image } from "utils/api/client/vendors/image"
import { Product } from "utils/api/client/vendors/product"
import { ProductCategory } from "utils/api/client/vendors/product-category"
import { Promotion } from "utils/api/client/vendors/promotion"
import { Order } from "utils/api/client/vendors/order"
import { User } from "utils/api/client/vendors/user"
import { Customer } from "./customer"
import { ProductQuantityDiscount } from "./product-quantity-discount"
import { ProductRewardPoint } from "./product-reward-point"
import { ProductStaBonus } from "./product-sta-bonus"
import { ProductStaPrice } from "./product-sta-price"
import { Taxes } from "./taxes"
import { Shippings } from "./shippings"
import { Setting } from "./setting"
import { ProductBulkImport } from "./product-bulk-import"
import { LiveCards } from "./live-card"
import { SaleRep } from "./sale-rep"
import { SaleProductGroup } from "./sale-product-group"
import { SaleCustomerGroup } from "./sale-customer-group"
import { TierPromotion } from "./tier-promotion"
import { BrandStore } from "./brand"
import { Principle } from "./principle"

export class Vendor {
  customer: Customer
  productCategory: ProductCategory
  productStaPrice: ProductStaPrice
  productStaBonus: ProductStaBonus
  productRewardPoint: ProductRewardPoint
  productQuantityDiscount: ProductQuantityDiscount
  user: User
  product: Product
  image: Image
  customerGroup: CustomerGroup
  promotion: Promotion
  order: Order
  taxes: Taxes
  shippings: Shippings
  productBulkImport: ProductBulkImport
  setting: Setting
  liveCard: LiveCards
  saleRep: SaleRep
  saleCustomerGroup: SaleCustomerGroup
  saleProductGroup: SaleProductGroup
  tierPromotion: TierPromotion
  brandStore: BrandStore
  principle: Principle

  constructor(client: unknown, _: unknown) {
    this.customer = new Customer(client)
    this.customerGroup = new CustomerGroup(client)
    this.user = new User(client)
    this.product = new Product(client)
    this.productCategory = new ProductCategory(client)
    this.image = new Image(client)
    this.promotion = new Promotion(client)
    this.productStaPrice = new ProductStaPrice(client)
    this.productStaBonus = new ProductStaBonus(client)
    this.productRewardPoint = new ProductRewardPoint(client)
    this.productQuantityDiscount = new ProductQuantityDiscount(client)
    this.order = new Order(client)
    this.taxes = new Taxes(client)
    this.shippings = new Shippings(client)
    this.productBulkImport = new ProductBulkImport(client)
    this.setting = new Setting(client)
    this.liveCard = new LiveCards(client)
    this.saleRep = new SaleRep(client)
    this.saleCustomerGroup = new SaleCustomerGroup(client)
    this.saleProductGroup = new SaleProductGroup(client)
    this.tierPromotion = new TierPromotion(client)
    this.brandStore = new BrandStore(client)
    this.principle = new Principle(client)
  }
}
